
import React from "react";

import Router from "./Router";
import { Provider } from "react-redux";
import  { persistor, store } from "./Store/store";
import { PersistGate } from "redux-persist/integration/react";


function App() {
  return (
    <>
        <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <Router />
        </PersistGate>
  </Provider>
         
    </>  
  );
}  

export default App;
